import { Popover } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import { InfoCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const ContentWrapper = styled.div`
  max-width: 400px;
`;

function InfoPopover({ content, placement, title }) {
  return (
    <Popover
      placement={placement}
      title={title}
      content={<ContentWrapper>{content}</ContentWrapper>}
    >
      <InfoCircleOutlined
        style={{ marginLeft: 8, color: '#F4A01D', fontSize: 10 }}
      />
    </Popover>
  );
}

InfoPopover.defaultProps = {
  placement: 'top',
  title: null,
};

InfoPopover.propTypes = {
  content: PropTypes.node.isRequired,
  placement: PropTypes.string,
  title: PropTypes.node,
};

export default InfoPopover;
